<!--
 * @Author: MouXiaowei
 * @Date: 2022-05-06 10:34:06
 * @Description: 活动页面，根据code从后端接口请求图片数组展示
-->

<template>
  <div class="img-box">
    <div v-for="(item, index) in imgList" :key="index">
      <img :src="item.img" @click="handlerJump(item)"/>
    </div>
<!--    <img v-for="(img, index) in imgList" v-lazy="img" :key="index" />-->
  </div>
</template>

<script>

import { setStore } from '@/utils/index'
import { getActivityTemplateImg, countAppCodeImageForward } from '@/api/active'

export default {
  data () {
    return {
      sourceApp: null,
      imgList: []
    }
  },
  created () {
    this.sourceApp = this.$route.query.sourceApp
  },
  mounted () {
    if (window._czc) {
      window._czc.push(['_trackEvent', '', '', '', '', this.$route.query.code])
    }
    const accessToken = this.$route.query.accessToken
    if (accessToken) {
      setStore('token', accessToken)
    }
    this.getList()
  },
  methods: {
    getList () {
      const code = this.$route.query.code
      getActivityTemplateImg(code).then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            if (res.data.result) {
              const arr = res.data.result
              this.imgList = arr
            }
          }
        }
      })
    },
    handlerJump (item) {
      const countFlag = item.countFlag
      if (countFlag === 1) {
        const id = item.id
        countAppCodeImageForward(id).then((res) => {
          if (res.data.code === 200) {
            console.log('处理成功')
          } else {
            console.log('处理失败' + res)
          }
        })
      }
      const flag = item.forwordFlag
      if (flag === 0) {
        return
      }

      const appType = item.appType

      if (appType === 1) {
        window.location.href = item.appStartUrl
        return
      }
      if (appType === 5) {
        window.location.href = 'bjqd://'
        setTimeout(function () {
          window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
        }, 1200)

        return
      }
      if (this.sourceApp === 'qdt') {
        if (appType === 10) {
          item.appType = 1
          item.goPage = item.appStartUrl
          item.finishCurrentPage = 1
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(item))
      } else {
        /* eslint-disable */
        dsBridge.call("callNativeViewLifeCycle", {
          ...item
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .img-box {
    min-height: 100vh;

    img {
      display: block;
      width: 100%;
    }
  }
</style>
